import { styled } from '@mui/material/styles';

export const PageLayoutRoot = styled('div')(({ collapsed }) => ({
    width: `calc(100% - ${collapsed ? '60px' : '250px'})`,
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    background: '#EDF3FA',
    padding: '40px',
    flexShrink: 0,
    boxSizing: 'border-box',
    transition: 'width 0.3s',
}));
